import React from 'react'

const BlessAbout = () => {
  return (
    <section className="innovation-banner" style={{ backgroundColor: "#df888a" }}>
    <h2 class="banner-title">Freedom never felt so empowering</h2>
  </section>
  )
}

export default BlessAbout